import LoadingScreen from "components/LoadingScreen";
import useAuth from "hooks/useAuth";
import AuthLayout from "layouts/AuthLayout";
import EmailPageContainer from "pages/email_send_page/skeleton/EmailPageContainer";
import { ReactNode, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "redux/store";

type AuthGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: AuthGuardProps) {
  const { allowed, isLoading } = useAuth();
  const supplier = useSelector((state: any) => state.supplier.supplier);
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (allowed && localStorage.getItem("token")) {
    const currentSupplierId = window.location.pathname.split("/")[1];
    console.log("currentSupplierId", currentSupplierId, supplier);
    if (supplier?.isOnboardingDone) {
      return <Navigate to={"/" + currentSupplierId + "/documents"} />;
    } else {
      return <Navigate to={"/" + currentSupplierId + "/onboarding"} />;
    }
  }

  if (!allowed || !localStorage.getItem("token")) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return (
      <AuthLayout>
        <EmailPageContainer />
      </AuthLayout>
    );
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
